import { AxiosError, AxiosResponse } from 'axios';
import { FormEvent } from 'react';

import { axios } from '@bai/data';

import { ValidationType } from './loginFeatureTypes';

export type LoginFeatureResponse = {
  StatusCode: number;
  ErrorMessage: string;
  ErrorNumber: number;
  data: unknown;
};

export async function handleLoginFeatureSubmit(
  event: FormEvent,
  endpoint: string,
  password: string | null,
  username: string | null,
): Promise<LoginFeatureResponse | string> {
  event.preventDefault();

  let requestParams = {};
  if (password !== null && username !== null) {
    requestParams = {
      Password: password,
      UserName: username,
    };
  } else if (username === null) {
    requestParams = {
      Password: password,
    };
  } else if (password === null) {
    requestParams = {
      UserName: username,
    };
  }

  const result: LoginFeatureResponse = {
    StatusCode: 0,
    ErrorMessage: '',
    ErrorNumber: 0,
    data: undefined,
  };

  try {
    const axiosResult = await axios.post<LoginFeatureResponse>(
      endpoint,
      requestParams,
    );

    result.ErrorMessage = axiosResult.data.ErrorMessage;
    result.StatusCode = axiosResult.status;
    result.ErrorNumber = axiosResult.data.ErrorNumber;
    result.data = axiosResult.data;

    return result;
  } catch (e) {
    const error = e as AxiosError;
    // Need to get the raw error message to retain whitespace characters in response
    const errorData = error.response?.data as
      | Partial<LoginFeatureResponse>
      | undefined;
    result.ErrorMessage =
      // if the error message is empty, a network error occurred so display generic error.
      (error.response as AxiosResponse)?.data?.ErrorMessage ??
      'A network error has occurred.';
    return result;
  }
}

export const loginFeatureValidator = (
  valdiationType: ValidationType,
  minLength: number | null,
  inputOrig: string,
  inputToMatch: string | null,
) => {
  // let errormsg = '';
  let valid = true;

  if (valdiationType === 1) {
    if (inputOrig.trim().length === 0) {
      // errormsg = 'required but empty';
      valid = false;
    }

    if (inputToMatch !== null && inputToMatch.trim().length === 0) {
      // errormsg = 'required but empty';
      valid = false;
    }
  }

  if (valdiationType === 2 && inputToMatch !== null) {
    if (inputOrig.trim() !== inputToMatch.trim()) {
      // errormsg = `values do not match comparing ${inputOrig} to ${inputToMatch}`;
      valid = false;
    }
  }

  if (valdiationType === 3 && minLength !== null) {
    if (inputOrig.trim().length < minLength) {
      // errormsg = `min length of ${minLength} not met length is ${inputOrig.length}`;
      valid = false;
    }
  }

  return valid;
};
export { ValidationType };
